import React from 'react'

import { CitizenAIChatMessage } from 'src/components/CitizenAIAssistant/CitizenAIAssistantContext'
import { T, VStack } from 'src/govwell-ui'
import ParsedHtmlMessage from 'src/pages/AIChat/AIResponseMessage/ParsedHtmlMessage'
import Toolbar from 'src/pages/AIChat/AIResponseMessage/Toolbar'

type Props = {
  message: CitizenAIChatMessage
}

const CitizenAIChatMessageItem = ({ message }: Props) => {
  const isUser = message.sender === 'user'
  const messageId = typeof message.id === 'number' ? message.id : undefined

  const displayText = message.text.replace(/<\/?$/, '')

  return (
    <div className={`flex w-full ${isUser ? 'justify-end' : 'justify-start'}`}>
      <VStack gap={1} width="auto" maxWidth="85%">
        <div
          className={`rounded-2xl px-4 py-2.5 ${
            isUser ? 'bg-neutral-900 text-white' : 'bg-white text-neutral-900 shadow-sm'
          }`}
        >
          {isUser ? (
            <T.Body className="text-white">{message.text}</T.Body>
          ) : (
            <>
              {displayText ? (
                <ParsedHtmlMessage html={displayText} />
              ) : message.isThinking ? (
                <T.Body className="animate-pulse text-neutral-500">Thinking...</T.Body>
              ) : null}
            </>
          )}
        </div>

        {!isUser && !message.isThinking && displayText && (
          <Toolbar html={displayText} id={messageId} />
        )}

        {message.citations && message.citations.length > 0 && (
          <div className="mt-1 ml-2">
            <T.BodySmall className="text-neutral-500">Sources:</T.BodySmall>
            <ul className="mt-1 list-inside list-disc text-sm text-neutral-600">
              {message.citations.map((citation) => (
                <li key={citation.id}>
                  {citation.aiTrainingMaterial?.file?.name ??
                    citation.codeBookItem?.formattedName ??
                    citation.violationCode?.display ??
                    citation.scrapedFile?.sourceUrl ??
                    'Source'}
                </li>
              ))}
            </ul>
          </div>
        )}
      </VStack>
    </div>
  )
}

export default React.memo(CitizenAIChatMessageItem)
